import { IListFilters } from 'types/List';

export enum DestinationType {
	CACC = 'CACC',
	SVGS = 'SVGS',
	TRAN = 'TRAN',
	SLRY = 'SLRY',
}

// valores gravados em key_type (PixKeyType no backend)
export enum DestinationKeyType {
	CPF = 'CPF',
	CNPJ = 'CNPJ',
	EMAIL = 'EMAIL',
	PHONE = 'PHONE',
	EVP = 'EVP',
}

export type DestinationDto = {
	taxpayer_id: string;
	name: string;
	bank: string;
	branch: string;
	account: string;
	type: DestinationType;
	id?: string;
	key?: string;
	key_type?: string;
	id_end_to_end?: string;
};

export type Destination = DestinationDto & {
	id: string;
};

export type DestinationCreator = {
	id: string;
	full_name: string;
	taxpayer_id: string;
};

export type DestinationListItem = Omit<Destination, 'key' | 'key_type'> & {
	key?: string | null;
	key_type?: string | null;
	creator?: DestinationCreator | null;
	created_at: string;
	has_unfinished_postings: boolean;
};

export type DestinationDeleteFailure = {
	account_destination_id: string;
	code: string;
	message: string;
};

export type DestinationsDeleteResult = {
	deleted: string[];
	failed: DestinationDeleteFailure[];
};

export type DestinationFilters = IListFilters & {
	id?: string;
	search?: string;
	account?: string;
	creator?: string;
	bank?: string;
	branch?: string;
	type?: DestinationType;
	key_type?: DestinationKeyType;
	created_at_start_date?: string | null;
	created_at_end_date?: string | null;
};
